import { useRef } from 'react';
import JoditEditor from 'jodit-react';

interface IEmailPreviewEditor {
  value?: string;
  onChange?: (html: string) => void;
  config?: any;
}

export const EmailPreviewEditor = ({ value, onChange, config }: IEmailPreviewEditor) => {
  const editor = useRef(null);
  return (
    <JoditEditor
      ref={editor}
      value={value}
      config={{
        ...config,
      }}
      onBlur={newContent => onChange?.(newContent)}
    />
  );
};
